import { TaskCard, TaskCardProps } from 'components/TaskCard/TaskCard';
import { ReactComponent as SurveyIcon } from 'assets/icons/SurveyIcon.svg';
import React from 'react';
import { SvgIcon } from 'components/SvgIcon/SvgIcon';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';

interface SurveyTaskCardProps extends Omit<TaskCardProps, 'taskTypeLabel' | 'icon'> {
  surveyName: string;
}

export const SurveyTaskCard = ({
  surveyName,
  careProgramName,
  isCompleted,
  onClick,
}: SurveyTaskCardProps) => {
  const { translation } = useTranslationContext();

  return (
    <TaskCard
      icon={<SvgIcon component={SurveyIcon} />}
      taskTypeLabel={translation('checklist_task_type_check_in')}
      taskName={surveyName}
      isCompleted={isCompleted}
      careProgramName={careProgramName}
      onClick={onClick}
    />
  );
};
